import { ApiClientBase } from "api/ApiClientBase";

class DictionariesApiClient extends ApiClientBase {
    getSportTypes() {
        return this.get(`api/v1/sport-types`).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new DictionariesApiClient();
